module.exports = __webpack_public_path__ + "static/media/cash.a6b0eadd.mp3";